import { Component, OnInit } from '@angular/core';
import { flatMap, map } from 'rxjs/operators';
import { CompanysitesService } from '../../company-sites/company-sites.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FatTopBarSetup } from '../../../layout/fat-top-bar-layout/fat-top-bar-layout.component';
import { Observable, combineLatest } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-site-system-layout',
  templateUrl: './site-system-layout.component.html',
  styleUrls: ['./site-system-layout.component.css']
})
export class SiteSystemLayoutComponent implements OnInit {
  layoutSetup: Observable<FatTopBarSetup>;
  userHaveAccess: Object;
  constructor(private auth: AuthService, private route: ActivatedRoute, private siteService: CompanysitesService, router: Router) {

    this.auth.user$.subscribe(user => {
      this.userHaveAccess = user['haveAccess']
    })
  }

  ngOnInit() {

    let siteIdObs = this.route.params.pipe(map(params => {
      return params['siteId'];
    }));

    let systemIdObs = this.route.children[0].params.pipe(map(params => {
      return params['systemId'];
    }));

    let nameObs = siteIdObs.pipe(flatMap(siteId => this.siteService.getSiteById(siteId).pipe(map(value => {
      return { name: value.data()['name'], siteId, data: value.data() };
    }))))

    let systemNameObs = siteIdObs.pipe(flatMap(siteId => this.siteService.getSiteSystemsByIdObs(siteId)));

    //systemNameObs.subscribe(systemName => console.log("systemName", systemName))
    // let systemObs = systemIdObs.pipe(flatMap(systemId => {
    //   return 
    // }))

    //systemIdObs.subscribe(siteId => console.log("systemIdObs system", siteId));

    let sitesObs = this.siteService.getSites$();

    this.layoutSetup = combineLatest(systemNameObs, sitesObs, siteIdObs, systemIdObs).pipe(map(values => {
      let links = [
        { name: "Overview", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] },
      ]

      if (this.userHaveAccess) {
        if (this.userHaveAccess['records']) links.push({ name: "Records", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/records" })
        if (this.userHaveAccess['inventory']) links.push({ name: "Inventory", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/inventory" })
      } else {
        links.push({ name: "Records", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/records" })
        links.push({ name: "Inventory", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/inventory" })
        links.push({ name: "JSD Logs", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/jsdlogs" })
      }

      let systemName = values[0].filter(system => system.systemId == values[3]).pop().name;
      return {
        title: "System: " + systemName,
        links
        // { name: "Transactions", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/transaction"}
        // { name: "Filling", path: "/dashboard/sites/" + values[2] + "/system/" + values[3] + "/stockfiller"}

        , sites: values[1]
      };
    }));
  }

}
